import React from 'react';
import PhysDialog from './PhysDialog';

// Confirmación con el mismo look que el modal de bienvenida (.success-content).
const ConfirmModal = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Aceptar',
  cancelText = 'Cancelar',
}) => (
  <PhysDialog
    isOpen={isOpen}
    onClose={onCancel}
    title={message}
    primary={{ label: confirmText, onClick: onConfirm }}
    secondary={{ label: cancelText, onClick: onCancel }}
  />
);

export default ConfirmModal;
